import React from "react";
import { Chip } from "@material-ui/core";
import tokens from "../designTokens";

// Fully-rounded status pill on MUI Chip, solid or subtle tone.
const TONES = {
  success: { c: tokens.success, tint: "#EAF5EA" },
  error: { c: tokens.error, tint: "#FDECEA" },
  warning: { c: tokens.secondary, tint: "#FFF6E0" },
  info: { c: tokens.info, tint: "#F3E9FF" },
  resolved: { c: tokens.resolved, tint: "#E9F2E9" },
  neutral: { c: tokens.textSecondary, tint: "#EFEFF2" },
};

export default function Badge({ children, tone = "neutral", subtle = false, size = "sm", style, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  const sizes = { sm: { height: 20, fontSize: 11 }, md: { height: 26, fontSize: 12.5 } };
  const s = sizes[size] || sizes.sm;
  const warmText = tone === "warning";
  return (
    <Chip
      size="small"
      label={children}
      style={{
        height: s.height,
        borderRadius: tokens.radiusPill,
        fontFamily: tokens.fontBody,
        fontWeight: 700,
        fontSize: s.fontSize,
        background: subtle ? t.tint : t.c,
        color: subtle ? t.c : warmText ? tokens.primary : "#fff",
        ...style,
      }}
      {...rest}
    />
  );
}
